import PropTypes from 'prop-types'
// import React from 'react'
import { I18n } from 'react-redux-i18n'
import Shepherd from 'tether-shepherd'

import Base from '../../containers/BaseContainer'
import Constants from '../../services/constants/Constants'

let tour = new Shepherd.Tour({
  defaults: {
    classes: 'shepherd-theme-arrows',
  },
})

class Tour extends Base {

  constructor (props) {
    super(props)
    this._bind('_handleCloseTour', '_handleDoneTour', '_handleErrorTour', '_transformTourToShepherd')
    this.state = {
      inTour: false,
      currentTour: '',
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    let nextTour = nextProps.tour

    if (nextTour !== '/account/myteam') {
      let editors = document.querySelectorAll('#editor')
      if (editors.length > 0) {
        let classList = editors[editors.length-1].classList.toString()
        // always use the latest (maybe more than one editor is opened)
        if (classList) {
          if (classList.indexOf('opened') > -1) {
            if (classList.indexOf('section') > -1) {
              nextTour += '/section'
            } else if (classList.indexOf('map') > -1) {
              nextTour += '/map'
            } else if (classList.indexOf('typePoi') > -1) {
              nextTour += '/typePoi'
            } else if (classList.indexOf('poi') > -1) {
              nextTour += '/poi'
            } else if (classList.indexOf('poiAction') > -1) {
              nextTour += '/poiAction'
            } else if (classList.indexOf('beaconAction') > -1) {
              nextTour += '/beaconAction'
            } else if (classList.indexOf('beacon') > -1) {
              nextTour += '/beacon'
            } else if (classList.indexOf('slideshow') > -1) {
              nextTour += '/slideshow'
            } else if (classList.indexOf('multipleChoicesActions') > -1) {
              nextTour += '/multipleChoicesActions'
            } else if (classList.indexOf('live') > -1) {
              nextTour += '/live'
            } else if (classList.indexOf('gallery') > -1) {
              nextTour += '/gallery'
            } else if (classList.indexOf('generic') > -1) {
              nextTour += '/generic'
            } else if (classList.indexOf('plan') > -1) {
              nextTour += '/plan'
            } else if (classList.indexOf('areaAction') > -1) {
              nextTour += '/areaAction'
            } else if (classList.indexOf('user') > -1) {
              nextTour += '/user'
            } else if (classList.indexOf('group') > -1) {
              nextTour += '/group'
            }
          }
        }
      }

      if (document.querySelector('#Library').classList.toString().indexOf('opened') > -1) {
        nextTour = '/library'
      }

      if (nextTour !== this.state.currentTour && this.state.inTour) {
        tour.cancel()
      }
      if (nextProps.showTour) {
        if (Constants.ToursConstants[nextTour]) {
          if (nextTour && !this.state.inTour) {
            this.setState({inTour: true, currentTour: nextTour})
            this._transformTourToShepherd(Constants.ToursConstants[nextTour])
          }
        } else {
          this.props.onMissingHelp()
        }
      } else {
        if (this.state.inTour) {
          tour.cancel()
          if (nextTour === this.state.currentTour) {
            this.setState({inTour: false})
          } else {
            this.setState({inTour: false, currentTour: ''})
          }
        }
      }
    } else {
      if (document.querySelector('#helpCustom')) {
        if (nextTour !== this.state.currentTour && this.state.inTour) {
          document.querySelector('#helpCustom').classList.remove('showSpecialHelp')
        }
        if (nextProps.showTour) {
          this.setState({inTour: true, currentTour: nextTour})
          document.querySelector('#helpCustom').classList.add('showSpecialHelp')
        } else {
          if (this.state.inTour) {
            document.querySelector('#helpCustom').classList.remove('showSpecialHelp')
            if (nextTour === this.state.currentTour) {
              this.setState({inTour: false})
            } else {
              this.setState({inTour: false, currentTour: ''})
            }
          }
        }
      }
    }
  }

  _transformTourToShepherd (tourObj) {
    tour = new Shepherd.Tour({
      defaults: {
        classes: 'shepherd-theme-arrows',
      },
    })

    let that = this
    tourObj.steps.forEach((step, index) => {
      let buttons = []
      if (index > 0) {
        buttons.push({
          text: I18n.t('Tour.prevBtn'),
          action: tour.back,
          classes: 'shepherd-button-example-primary',
        })
      }
      if (index < tourObj.steps.length-1) {
        buttons.push({
          text: I18n.t('Tour.nextBtn'),
          action: tour.next,
          classes: 'shepherd-button-example-primary',
        })
        buttons.push({
          text: I18n.t('Tour.closeBtn'),
          classes: 'shepherd-button-secondary',
          action: function () {
            tour.cancel()
            that._handleCloseTour()
          },
        })
      }
      if (index === tourObj.steps.length-1) {
        buttons.push({
          text: I18n.t('Tour.doneBtn'),
          classes: 'shepherd-button-primary',
          action: function () {
            tour.cancel()
            that._handleDoneTour()
          },
        })
      }

      tour.addStep(tourObj.id+'-'+index, {
        title: step.title,
        text: step.content,
        attachTo: step.target + ' ' + step.placement,
        buttons,
      })
    })

    tour.start()
  }

  _handleErrorTour () {
    this._handleDoneTour()
  }

  _handleCloseTour () {
    this._handleDoneTour()
  }

  _handleDoneTour () {
    this.props.onEndTour()
  }

  render () {
    return null
  }
}

Tour.propTypes = {
  tour: PropTypes.string.isRequired,
  showTour: PropTypes.bool,
  onEndTour: PropTypes.func,
  onMissingHelp: PropTypes.func,
}

export default Tour
